<template>
   <v-app>
      <div class="animated fadeIn">

         <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

         <h1>{{ $t('nav.monitoring_racks_in_dc') }}</h1>

         <v-card outlined max-width="400">
               <h4>{{ $t('subtitles.filters') }} :</h4>
            <v-form>
              <b-radio-group id="equ_on_front" v-model="filters.equ_on_front" @change="change_equ_on_front">
                <b-radio :value="true">AVANT</b-radio>
                <b-radio :value="false">ARRIERE</b-radio>
              </b-radio-group>
              <b-radio-group id="dtc_pk" v-model="filters.dtc_pk" @change="change_dtc_pk">
                <b-radio :value="1">DDO-99</b-radio>
                <b-radio :value="2">DDO-125</b-radio>
                <b-radio :value="null">Tous</b-radio>
              </b-radio-group>
            </v-form>
         </v-card>

         <div v-for="datacenter in items" :key="datacenter.dtc_pk">
            <div v-if="datacenter.visible">
               <h2>{{ $t('nav.dtc_one') }} : {{ datacenter.name }}</h2>
               <div v-for="row in datacenter.children" :key="row.dtr_pk">
                  <div v-if="datacenter.visible">
                     <h3>{{ $t('nav.dtr_one') }} : {{ row.name }}</h3>
                     <v-row>
                        <v-card class="mx-1" cols="1" v-for="rack in row.children" :key="rack.rck_pk">
                           <v-btn class="warning" small width="100%"><small>{{ rack.name}}</small></v-btn>
                           <div v-for="position in rack.positions.slice().reverse()" :key="position._pk">
                              <v-btn-toggle>
                                 <v-btn readonly class="grey"    x-small width="20px" >{{ position._pk }}</v-btn>
                                 <v-btn readonly class="primary" x-small width="120px" v-if="position.equ && position.equ.visible"><small><small>{{ position.equ.name}}</small></small></v-btn>
                                 <v-btn disabled class="light"   x-small width="120px" v-else></v-btn>
                              </v-btn-toggle>
                           </div>
                        </v-card>
                     </v-row>
                  </div>
               </div>
            </div>
         </div>

      </div>
   </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue'

export default {
   name: 'physicalequipments',
   components: {
      ddoAlert,
      ddoWaiting,
   },
   data: () => {
      return {
         _this: null,
         loading: false,
         rows: [],
         items: [],
         filters: { dtc_pk: 1, dtr_pk: null, equ_on_front: true }
      }
   },

   async created() {
      this._this = this;
      var { errorinfos, api_response } = await this.refresh_rows();
      this.prepare_structure(this.rows);
      this.build_structure();
      this.filter_structure();
   },

   async mounted() {
   },

   methods: {

      async refresh_rows() {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,'equipment/datacenters');
         this.loading = false;
         this.rows = [];
         if ( api_response.error==0 ) {
            this.rows = api_response.rows;
         }
         return { errorinfos, api_response }
      },

      prepare_structure(rows) {
         for ( var i=0;i<rows.length;i++ ) {
            if ( rows[i].dtc_pk!=null && rows[i].dtr_pk!=null && rows[i].rck_pk!=null ) {
               var DTC = this.$api._get_by_pk(this.items,rows[i].dtc_pk);
               if ( DTC==null ) {
                  this.items.push( { _pk: rows[i].dtc_pk, name: rows[i].dtc_code, visible: true, children: [] } );
                  DTC = this.$api._get_by_pk(this.items,rows[i].dtc_pk);
               }
               var DTR = this.$api._get_by_pk(DTC.children,rows[i].dtr_pk);
               if ( DTR==null ) {
                  DTC.children.push( { _pk: rows[i].dtr_pk, name: rows[i].dtr_code, visible: true, max_height: rows[i].rck_size_u, children: [] } );
                  DTR = this.$api._get_by_pk(DTC.children,rows[i].dtr_pk);
               }
               //console.log('prepare_structure, DTR='+DTR.name+', max_height='+DTR.max_height+', rck.name='+rows[i].rck_code+', size='+rows[i].rck_size_u)
               if ( rows[i].rck_size_u > DTR.max_height ) { DTR.max_height = rows[i].rck_size_u }
               var RCK = this.$api._get_by_pk(DTR.children,rows[i].rck_pk);
               if (RCK==null ) {
                  DTR.children.push( { _pk: rows[i].rck_pk, name: rows[i].rck_code, visible: true, positions: [], children: [] } );
                  RCK = this.$api._get_by_pk(DTR.children,rows[i].rck_pk);
               } else {
                  RCK.children.push( { _pk: rows[i].equ_pk, name: rows[i].equ_name, visible: true, on_front: rows[i].equ_on_front, position_from: rows[i].equ_position_from, position_to: rows[i].equ_position_to} );
               }  
            }
         }
      },

      build_structure() {
         for ( var i=0;i<this.items.length;i++) {                                // Loop on Datacenters
            for ( var j=0;j<this.items[i].children.length;j++) {                 // Loop on Rows
               for ( var k=0;k<this.items[i].children[j].children.length;k++) {  // Loop on Racks
                  for ( var z=0;z<this.items[i].children[j].max_height;z++) {    // Loop on U position
                     this.items[i].children[j].children[k].positions.push( { _pk: z+1 } );
                  }
                  for ( var y=0;y<this.items[i].children[j].children[k].children.length;y++ ) { // Loop on equipments
                     let equ = this.items[i].children[j].children[k].children[y];
                     //console.log('build_structure, equ='+JSON.stringify(equ))
                     for ( var x=equ.position_from;x<=equ.position_to;x++ ) {
                        this.items[i].children[j].children[k].positions[x-1] = { _pk: x, equ: equ };
                     }
                  }            
               }
            }
         }
         //console.log('build_datacenters, items='+JSON.stringify(this.items));
      },

      change_equ_on_front(value) {
         this.filters.equ_on_front=value;
         this.filter_structure();
      },

      change_dtc_pk(value) {
         this.filters.dtc_pk=value;
         this.filter_structure();
      },

      filter_structure() {
         if ( this.filters.dtc_pk!=null) { this.filters.dtc_pk=parseInt(this.filters.dtc_pk); }
         if ( this.filters.dtr_pk!=null) { this.filters.dtr_pk=parseInt(this.filters.dtr_pk); }
         for ( var i=0;i<this.items.length;i++ ) {
            if ( this.filters.dtc_pk!=null ) {
               this.items[i].visible = ( this.items[i]._pk==this.filters.dtc_pk ? true : false );
            } else {
               this.items[i].visible = true;
            }
            for ( var j=0;j<this.items[i].children.length;j++ ) {
               if ( this.filters.dtr_pk!=null ) {
                  this.items[i].children[j].visible = ( this.items[i].children[j]._pk==this.filters.dtr_pk ? true : false );
               } else {
                  this.items[i].children[j].visible = true;
               }
               for ( var k=0;k<this.items[i].children[j].children.length;k++ ) {
                  if ( this.items[i].children[j].children[k].positions ) {
                     for ( var z=0;z<this.items[i].children[j].children[k].positions.length;z++ ) {
                        if ( this.items[i].children[j].children[k].positions[z].equ ) {
                           if ( this.filters.equ_on_front!==null ) {
                              this.items[i].children[j].children[k].positions[z].equ.visible = ( this.items[i].children[j].children[k].positions[z].equ.on_front===this.filters.equ_on_front ? true : false );
                           } else {
                              this.items[i].children[j].children[k].positions[z].equ.visible = true;
                           }
                        }
                     }
                  }
               }
            }
         }
      },
   }
}
</script>